import { Navigate, useSearchParams } from 'react-router-dom'

type LadderHubRedirectProps = {
  forceCreate?: boolean
}

export function LadderHubRedirect({ forceCreate = false }: LadderHubRedirectProps) {
  const [searchParams] = useSearchParams()
  const createRaw = String(searchParams.get('create') || '').trim().toLowerCase()
  const createMode = forceCreate || createRaw === '1' || createRaw === 'true' || createRaw === 'yes'
  const orgId = String(searchParams.get('orgId') || '').trim()
  const query = new URLSearchParams()
  if (orgId) query.set('orgId', orgId)
  const suffix = query.toString()
  if (createMode) {
    return <Navigate to={suffix ? `/ladders/new?${suffix}` : '/ladders/new'} replace />
  }
  return <Navigate to={suffix ? `/ladders?${suffix}` : '/ladders'} replace />
}
